import { mapState } from 'vuex'
import Vue from 'vue'
import appliesFilters from './applies-filters'

Vue.mixin({
  computed: {
    ...mapState('app', {
      $loading: 'loading'
    }),

    ...mapState('auth', {
      $user: 'user'
    }),

    $userIsAdmin () {
      return this.$user.role === 'admin'
    },

    $userIsCoordinator () {
      return this.$user.role === 'coordinator'
    },

    $userIsManager () {
      return this.$user.role === 'manager'
    },

    $userIsGraduate () {
      return this.$user.role === 'graduate'
    }
  }
})

export {
  appliesFilters
}
